import React from 'react';
import { Form, Label } from 'semantic-ui-react';

import CodeEditor, { CodeEditorProps } from '@src/components/Form/common/CodeEditor';

import CustomLabel from './CustomLabel';

interface FormJsonEditorProps extends CodeEditorProps {
  label: string;
  sublabel?: string;
  required?: boolean;
  fieldName: string;
  errors?: any;
}

export const FormJsonEditor = ({
  label,
  sublabel,
  errors = {},
  required = false,
  fieldName,
  ...rest
}: FormJsonEditorProps) => {
  return (
    <Form.Field required={required}>
      {errors[fieldName] && (
        <Label color="red" pointing="below">
          {errors[fieldName]}
        </Label>
      )}
      <CustomLabel label={label} sublabel={sublabel} />

      <CodeEditor title="Cover geometry viewer" readOnly {...rest} />
    </Form.Field>
  );
};
